import { getUser } from "helpers/storage";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// ==============================|| MINIMAL LAYOUT ||============================== //

const agencyRoutes = ["/gladstone-pharma","/aristo"];
const MinimalLayout = () => {
  let location = useLocation();
  const user = getUser();

  console.log("user==>", user);

  const publicRoutes = [
    "/login",
    "/verify",
    "/press-release",
    "/press-release-pdf",
    "/redirect-to-dashboard",
    "/press-release-preview",
    "/event/apicon",
    "/event/globalmeetingofMGB-OAGB2024",
    "/signup",
    "/payment-page",
    "/sso/login",
    ...agencyRoutes,
  ];

  if (!user && !publicRoutes.some((route) => location.pathname.startsWith(route))) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default MinimalLayout;
